import React from 'react';
import {Input} from './Input';
import InputMask from 'react-input-mask';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { connect } from 'react-redux';
import { Clients } from '@components/clients';
import { makeStyles } from '@material-ui/core/styles';
import debounce from "lodash/debounce";

const mapStateToProps = (state, props) => ({});

const actions = {
    findClients: Clients.actions.findClients,
};

const useStyles = makeStyles((theme) => ({
    root: {
        position: 'relative',
    },
    clientsList: {
        position: 'absolute',
        top: 'calc(100% - 4px) !important',
        left: 0,
        width: '100%',
        zIndex: 10,
        boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
        borderRadius: 4,
        background: 'white',
        padding: '8px 0px',

        '& .MuiListItem-root': {
            padding: '6px 16px'
        },
    },
}));

export const ClientPhoneAutocomplete = connect(mapStateToProps, actions)((props) => {
    const classes = useStyles();

    const [clients, setClients] = React.useState([]);
    const [isClientsPanelOpen, setClientsPanelOpen] = React.useState(false);
    const anchorRef = React.useRef(null);

    let {
        value = '',
        label,
        onChange,
        errors = {},
        name = 'phone',
        required = true,
        disabled = false,
        findClients,
        clientSelected,
        ...other
    } = props;

    const getClientsList = async (phone) => {
        let response = await findClients(phone.replaceAll(/[^\d]/g, ''));
        setClients(response.data);
    }

    const getClientsListDebounce = React.useCallback(debounce((phone) => getClientsList(phone), 600), []);

    return (<div className={classes.root}
        onFocus={() => setClientsPanelOpen(true)}
        onBlur={() => setTimeout(() => {setClientsPanelOpen(false)}, 100)}
    >
        <InputMask
            mask="+38(\099)999-99-99"
            value={value}
            onChange={({target: {value}}) => {
                onChange(value);
                getClientsListDebounce(value);
            }}
            alwaysShowMask={true}
            disabled={disabled}
            ref={anchorRef}
        >
            {(inputProps) => <Input
                {...inputProps}
                type="tel"
                name={name}
                errors={errors}
                variant="standard"
                size={'small'}
                required={required}
                disabled={disabled}
                fullWidth
                placeholder = '+38(050)123-45-67'
                id={name}
                label={label}
                {...other}
            />}
        </InputMask>

        {isClientsPanelOpen && <List className={classes.clientsList}>
            {clients.length > 0
                ? <>
                    {clients.slice(0, 2).map((client, index) =>
                        <ListItem
                            key={`client_${index}`}
                            button
                            onClick={(e) => props.clientSelected(client)}
                        >
                            <ListItemText
                                primary={`${client.name || 'Клиент'}, тел.: ${client.phones.map(phone => phone.phone).join(', ')}`}
                            />
                        </ListItem>
                    )}
                    {clients.length > 2 && <ListItem>
                        <ListItemText
                            style={{color: '#9e9e9e'}}
                            primary={`еще клиентов: ${clients.length - 2} `}
                        />
                    </ListItem>}
                </>
                : <ListItem>
                    <ListItemText primary={'Ничего не найдено'} />
                </ListItem>
            }
        </List>}
    </div>)
});
